import React from 'react';
import { PriceGroupItemComponent } from './PriceGroupItem';
import { PriceGroupHeadline, PriceGroupItemsWrapper } from './pricebreakdown.styles';
export const PriceGroupComponent = ({ priceGroup }) => {
    if (!priceGroup)
        return null;
    return (React.createElement(React.Fragment, null,
        (priceGroup === null || priceGroup === void 0 ? void 0 : priceGroup.label) && (React.createElement(PriceGroupHeadline, { tag: "p", "data-testid": "price-group-label", variant: { order: '2', style: 'bold' } }, priceGroup === null || priceGroup === void 0 ? void 0 : priceGroup.label)),
        React.createElement(PriceGroupItemsWrapper, null, priceGroup === null || priceGroup === void 0 ? void 0 : priceGroup.items.map((priceGroupItem) => (React.createElement(PriceGroupItemComponent, { priceGroupItem: priceGroupItem, key: priceGroupItem.label }))))));
};
